import React, { useEffect, useState } from "react";
import { AboutData } from "../../constants/interfaces";

interface AboutProps {
  data: AboutData
}



export const About = (props: AboutProps) => {

  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    window.addEventListener('resize', handleResize);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div id="about">
      <div className="container">
        <div className="row">
          {/*<div className="col-xs-12 col-md-6">
        {" "}
        <img src="img/about.jpg" className="img-responsive" alt="" />{" "}
      </div>*/}
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Who We Are</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              <a href="/about" type="button" className="btn btn-primary btn-lg"
                style={{ color: '#ffffff', backgroundColor: '#0573e8' }}>Learn More</a>
            </div>
          </div>
          {!isMobile && <div className="col-md-4 d-none d-md-block" style={{ marginLeft: '50px' }}>
            <img
              src={'/img/headerimg.png'}  // Replace with the correct image path
              alt="Logo"
              style={{ width: "125%", height: "auto" }} // Adjust size and spacing
            />
          </div>}
        </div>
      </div>
    </div>
  );
};
